module.exports = __webpack_public_path__ + "static/media/loading.e76be07a.gif";